import { Center, Loader } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { errorMessage } from '@/api/errors';
import { useRun } from '@/api/runs';
import { EmptyState } from '@/components/EmptyState';
import { usePageTitle } from '@/components/usePageTitle';
import { RUN_TABS, RunDetail, type RunTab } from '@/features/runs/RunDetail';

export const Route = createFileRoute('/_staff/staff/runs/$runId')({
  validateSearch: (s: Record<string, unknown>): { tab?: RunTab } => ({
    tab: (RUN_TABS as readonly unknown[]).includes(s.tab) && s.tab !== 'overview' ? (s.tab as RunTab) : undefined,
  }),
  component: RunPage,
});

function RunPage() {
  const { runId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate();
  const run = useRun(runId);
  usePageTitle(runId);
  if (run.isPending)
    return (
      <Center py="xl">
        <Loader color="forest" />
      </Center>
    );
  if (run.isError) return <EmptyState title={errorMessage(run.error)} />;
  return (
    <RunDetail
      run={run.data}
      tab={tab ?? 'overview'}
      onTabChange={(next) => void navigate({ to: '.', search: { tab: next === 'overview' ? undefined : next }, replace: true })}
    />
  );
}
